import React from "react";
import appData from "data/app.json";

const LoadingScreen = () => {

  return (
    <>
      <div className={`${appData.showLoading === true ? "showX" : "hideX"}`}>
        <div className="loading">
          <span>L</span>
          <span>o</span>
          <span>a</span>
          <span>d</span>
          <span>i</span>
          <span>n</span>
          <span>g</span>
        </div>
        <div id="preloader"></div>
      </div>
    </>
  );
};

export default LoadingScreen;
